var c = (e, o = []) => ({
  parts: (...a) => {
    if (d(o))
      return c(e, a);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...a) => c(e, [...o, ...a]),
  rename: (a) => c(a, o),
  keys: () => o,
  build: () => [...new Set(o)].reduce(
    (a, r) => Object.assign(a, {
      [r]: {
        selector: [
          `&[data-scope="${t(e)}"][data-part="${t(r)}"]`,
          `& [data-scope="${t(e)}"][data-part="${t(r)}"]`
        ].join(", "),
        attrs: { "data-scope": t(e), "data-part": t(r) }
      }
    }),
    {}
  )
}), t = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), d = (e) => e.length === 0;
export {
  c as createAnatomy
};
